@let org = selectActiveOrganization$ | async;
<div class="menu-level1 flex-col space-between-center h-100">
  <div class="flex-col">
    <span
      class="lumix-logo ui-icon-lumana-logo flex-col center-center"
      aria-label="Lumix logo"
    ></span>
    @if (isDeveloper$ | async) {
      <div
        class="menu-item"
        *rbacOrgAllow="[
          permissions.PortalManagement,
          permissions.Inspector,
          permissions.InspectorSupervisor,
        ]"
        [matTooltip]="'SIDEBAR.APPS' | translate"
        matTooltipClass="sidebar-tooltip"
        matTooltipPosition="right"
        [matTooltipDisabled]="appsMenuDropdown.isOpen"
      >
        <app-ui-dropdown #appsMenuDropdown [height]="appsMenuHeight">
          <a class="menu-item flex-row center-center w-100" input>
            <span class="ui-icon-apps icon"></span>
          </a>
          <ng-template #contentTemplate>
            @if (org) {
              <app-apps-menu
                [appId]="appId"
                [dropdown]="appsMenuDropdown"
                [orgId]="org._id"
                [webUrl]="webUrl"
                [controlCenterUrl]="controlCenterUrl"
                [parkingUrl]="parkingUrl"
                [sitePlannerUrl]="sitePlannerUrl"
                [panicUrl]="panicUrl"
                [chatUrl]="chatUrl"
                [isChatAllowed]="
                  (isDeveloper$ | async) === true &&
                  org.settings?.chatStatus === true
                "
                (switchApp)="switchApp($event)"
                #appsMenu
              ></app-apps-menu>
            }
          </ng-template>
        </app-ui-dropdown>
      </div>
    }
    <hr class="hr" />
    <div
      class="menu-item"
      [matTooltip]="'SIDEBAR.VIOLATIONS' | translate"
      routerLinkActive="active"
      matTooltipClass="sidebar-tooltip"
      matTooltipPosition="right"
    >
      <a
        class="flex-row center-center"
        [routerLink]="['/', routerSegments.violations]"
      >
        <span class="ui-icon-incident icon"></span>
      </a>
    </div>
    <div
      class="menu-item"
      [matTooltip]="'SIDEBAR.ANALYTICS' | translate"
      matTooltipClass="sidebar-tooltip"
      matTooltipPosition="right"
    >
      <a class="flex-row center-center">
        <span class="ui-icon-object-analytic icon"></span>
      </a>
    </div>
    <div
      class="menu-item"
      [matTooltip]="'SIDEBAR.CAMERA' | translate"
      matTooltipClass="sidebar-tooltip"
      matTooltipPosition="right"
    >
      <a class="flex-row center-center">
        <span class="ui-icon-object-camera icon"></span>
      </a>
    </div>
    <div
      class="menu-item"
      [matTooltip]="'SIDEBAR.CAMERA' | translate"
      matTooltipClass="sidebar-tooltip"
      matTooltipPosition="right"
    >
      <a class="flex-row center-center">
        <span class="ui-icon-extend icon"></span>
      </a>
    </div>
  </div>
  <div class="bottom-menu flex-col start-start w-100">
    <div
      class="user-icon-wrapper flex-row center-center"
      [matTooltip]="'SIDEBAR.USER' | translate"
      matTooltipClass="sidebar-tooltip"
      matTooltipPosition="right"
    >
      <app-ui-dropdown #userMenuDropdown [height]="userMenuHeight">
        <div class="flex-row center-center w-100" input>
          <span class="user-icon icon ui-icon-user"></span>
        </div>

        <ng-template #contentTemplate>
          <div #userMenu class="user-menu">
            <div class="user-menu-inner flex-col">
              <ng-container *ngIf="selectUser$ | async as user">
                <div class="menu-title">
                  {{ user.firstname }} {{ user.lastname }}
                </div>
                <div class="menu-title">
                  {{ user.email }}
                </div>
              </ng-container>
              <hr class="hr" />
              <a
                routerLink="/account-details"
                (click)="trackNavigationEvent(analyticsEvents.openUserProfile)"
                class="menu-item flex-row space-between-center"
              >
                <div class="flex-row start-center gap-8">
                  <span class="icon ui-icon-user"></span>
                  <span>{{
                    'USER_MENU.ACCOUNT_DETAILS_TITLE' | translate
                  }}</span>
                </div>
              </a>
              <div
                (click)="logout(); userMenuDropdown.toggleDropdown()"
                class="menu-item logout-button flex-row space-between-center"
              >
                <div class="flex-row start-center gap-8">
                  <span class="icon ui-icon-logout"></span>
                  <span>{{ 'USER_MENU.LOGOUT' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </app-ui-dropdown>
    </div>
    <hr class="hr" />
    <div
      class="org-icon-wrapper flex-row center-center"
      [matTooltip]="'SIDEBAR.ORGANIZATION' | translate"
      matTooltipClass="sidebar-tooltip"
      matTooltipPosition="right"
    >
      @if (org) {
        <app-ui-dropdown #orgMenuDropdown [height]="orgMenuHeight">
          <div
            class="flex-row center-center w-100"
            (click)="trackNavigationEvent(analyticsEvents.openOrganization)"
            input
          >
            <ui-avatar
              class="org-avatar"
              [name]="org.settings.orgName"
              [color]="org.settings.orgColor"
            ></ui-avatar>
          </div>
          <ng-template #contentTemplate>
            <div #orgMenu class="user-menu">
              <div class="user-menu-inner flex-col">
                <div
                  class="active-organization organization-item title flex-row start-center gap-8"
                >
                  <div uiTruncateText class="truncated-name">
                    {{ org.settings.orgName }}
                  </div>
                </div>
                <hr class="hr" style="margin: 12px 8px 12px 8px" />
                <div class="menu-item">
                  <div class="flex-row start-center gap-8">
                    <span class="icon ui-icon-company"></span>
                    <span>{{ 'SIDEBAR.SWITCH_ORGANIZATION' | translate }}</span>
                  </div>
                </div>
                <a
                  [routerLink]="['/', routerSegments.organizationSettings]"
                  (click)="orgMenuDropdown.toggleDropdown()"
                  class="menu-item flex-row space-between-center"
                >
                  <div class="flex-row start-center gap-8">
                    <span class="icon ui-icon-settings"></span>
                    <span>{{ 'SIDEBAR.SETTINGS' | translate }}</span>
                  </div>
                </a>
              </div>
            </div>
          </ng-template>
        </app-ui-dropdown>
      }
    </div>
  </div>
</div>
